import { render } from "./DistributorIntegrations.vue?vue&type=template&id=54169e4e"
import script from "./DistributorIntegrations.vue?vue&type=script&lang=js"
export * from "./DistributorIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__